import React, {useState, useEffect} from "react";
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography, Fab
} from "@mui/material";
import MyCalendar from "../components/MyCalendar";
import MyAlarm from "../components/MyAlarm";
import FixedBottomNavigation from "../components/FixedBottomNavigation";
import HeaderBar from "../components/HeaderBar"; // 
import { supabase } from "../supabaseClient";
import AddIcon from '@mui/icons-material/Add';
import ScheduleDialog from "../components/ScheduleDialog";

const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index} style={{ width: "100%" }}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

const Profile = () => {
  const [user, setUser] = useState(null); // ✅ 사용자 정보 상태 추가
  const [tabIndex, setTabIndex] = useState(0); // 탭 상태
  const [openDialog, setOpenDialog] = useState(false);
  const [reloadKey, setReloadKey] = useState(0); 
  const [selectedDate, setSelectedDate] = useState(null);

  const handleOpenDialogWithDate = (date) => {
    setSelectedDate(date);
    setOpenDialog(true);
  };

  useEffect(() => {
    let isMounted = true; // ✅ 컴포넌트가 언마운트되었는지 체크

    // ✅ onAuthStateChange 구독 및 클린업 처리
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => {
      if (isMounted){
        setUser(session?.user ?? null);
      }
    });

    return () => {
      isMounted = false; // ✅ 언마운트 시 API 호출 막기
      subscription?.unsubscribe(); // ✅ 구독 해제
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleSaveSchedule = () => {
    setReloadKey(prev => prev + 1); // 트리거 변경
    setOpenDialog(false); // 다이얼로그 닫기
  };
  
  return (
    <Container sx={{ pb: 7, pt: 7, pl:1, pr:1 }}>
      {/* 🔹 헤더 영역 */}
      <HeaderBar title="프로필" showBack />
      <Box sx={{ pt:1,borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabIndex} onChange={handleTabChange} variant="fullWidth">
          <Tab label="내 예약현황" />
          <Tab label="내 알림현황" />
        </Tabs>
      </Box>
      {user ? (
        <>
          <TabPanel value={tabIndex} index={0}>
            <MyCalendar 
              userId={user.id} 
              reloadTrigger={reloadKey} 
              onDateSelect={handleOpenDialogWithDate}
              sx={{backgroundColor:'white'}} 
            />
            <Box sx={{pb:10}}></Box>
            <Fab color="primary" aria-label="add" sx={{position:"Fixed",right:10,bottom:80,opacity:0.8}} onClick={() => setOpenDialog(true)}>
              <AddIcon />
            </Fab>
          </TabPanel>
          <TabPanel value={tabIndex} index={1}>
            <MyAlarm userId={user.id} />
          </TabPanel>

          <ScheduleDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            userId={user.id}
            onSave={handleSaveSchedule}
            initialDate={selectedDate}
          />
        </>
      ) : (
        <Typography sx={{ mt: 4 }}>사용자 정보를 불러오는 중...</Typography>
      )}
      
      <FixedBottomNavigation />
    </Container>
  );
};

export default Profile;
